
(function () {
var CTX = window.HHCrew; if (!CTX) return;
var STATE = CTX.STATE, CFG = CTX.CFG || {};
var GRIP = CFG.gripHandle || 'heavy-duty-black-nitrile-gloves-50-pack';
function focus() { return STATE && STATE.f && STATE.f.focus; }
function money(c) { return '$' + (Math.round(c) / 100).toFixed(2); }
function pctFor(qbx) { return (window.HH_PRICE && window.HH_PRICE.pctFor) ? window.HH_PRICE.pctFor(GRIP, qbx) : 0; }
function unitAfter(c, p) { return (window.HH_PRICE && window.HH_PRICE.unitAfter) ? window.HH_PRICE.unitAfter(c, p) : c; }
function planCents() { var c = focus(); return (c && c.lines && c.lines[0]) ? Math.round(c.lines[0].planPerBox * 100) : 0; }
function reorderActions() {
var wrap = document.querySelector('.hhx-actions'); if (!wrap) return;
var order = ['qty', 'skip', 'unskip', 'size', 'delay', 'freq', 'pause', 'sendnow'];
var by = {}; wrap.querySelectorAll('[data-act]').forEach(function (b) { by[b.getAttribute('data-act')] = b; });
order.forEach(function (a) { if (by[a]) wrap.appendChild(by[a]); });
}
function renames() {
document.querySelectorAll('.hhx-soon summary').forEach(function (s) {
if (/also coming up/i.test(s.textContent)) s.textContent = 'Your Scheduled Deliveries';
});
document.querySelectorAll('.hhx-next .hhx-eyebrow').forEach(function (p) {
if (/your next box/i.test(p.textContent)) p.textContent = 'Your next delivery';
});
}
function takeText() {
var take = document.querySelector('[data-hhx-take]'); var track = document.querySelector('[data-hhx-track]');
if (!take || !track) return;
var per = parseInt(track.getAttribute('data-per'), 10) || 30;
var into = parseInt(track.getAttribute('data-into'), 10) || 0;
var c = focus(); var add = (c && c.boxes) || 0; if (add <= 0) return;
var proj = Math.min(into + add, per);
if (proj >= per) take.innerHTML = 'This delivery earns your next <b>free box</b> &#127873;';
else take.innerHTML = 'This delivery takes you to <b>' + proj + '/' + per + '</b> &mdash; ' + (per - proj) + ' to go for a free box (added on your first paid order after ' + per + ').';
}
function onRender() { reorderActions(); renames(); takeText(); }
function wrapFreq() {
var a = CTX.act; if (!a || typeof a.freq !== 'function') return;
var orig = a.freq;
a.freq = function () {
var r = orig.apply(this, arguments);
setTimeout(function () {
var cur = document.querySelector('.hhx-sheet-wrap .hhx-sheet input[name="fq"]:checked');
var label = cur && cur.closest('label'); if (label) label.remove();
}, 0);
return r;
};
}
function wireImpact() {
var sel = document.getElementById('hhxBoxes'); if (!sel || sel.__hhimp) return; sel.__hhimp = 1;
var out = document.createElement('p'); out.className = 'hhx-cf-impact'; out.hidden = true;
sel.parentNode.appendChild(out);
function upd() {
var c = focus(); var pc = planCents();
var m = (sel.value || '').match(/(\d+)/);
if (!c || !pc || !m) { out.hidden = true; return; }
var nq = parseInt(m[1], 10); var cur = c.boxes || 0;
var newPer = unitAfter(pc, pctFor(nq)); var curPer = unitAfter(pc, pctFor(cur));
var diff = curPer - newPer;
var pct = curPer ? Math.round(Math.abs(diff) / curPer * 100) : 0;
if (nq > cur && diff > 0) {
out.className = 'hhx-cf-impact hhx-cf-impact--up';
out.innerHTML = 'At ' + nq + ' boxes: <b>' + money(newPer) + '/box</b> &mdash; save ' + money(diff) + '/box (' + pct + '%), ' + money(diff * nq) + ' every delivery.';
out.hidden = false;
} else if (nq < cur && diff < 0) {
out.className = 'hhx-cf-impact hhx-cf-impact--down';
out.innerHTML = 'Heads up: at ' + nq + ' boxes you lose volume pricing &mdash; <b>' + money(newPer) + '/box</b> (+' + money(-diff) + '/box, ' + pct + '% more).';
out.hidden = false;
} else { out.hidden = true; }
}
sel.addEventListener('change', upd); upd();
}
var stockCache = null;
function loadStock() {
if (stockCache) return Promise.resolve(stockCache);
var h = CFG.gripHandle || 'heavy-duty-black-nitrile-gloves-50-pack';
return fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
.then(function (r) { return r.json(); })
.then(function (p) { stockCache = {}; (p.variants || []).forEach(function (v) { stockCache[String(v.id)] = !!v.available; }); return stockCache; })
.catch(function () { return {}; });
}
function markStockOnce() {
var sheet = document.querySelector('.hhx-sheet-wrap .hhx-sheet'); if (!sheet) return false;
var radios = sheet.querySelectorAll('input[name="sz"]'); if (!radios.length) return false;
loadStock().then(function (stock) {
radios.forEach(function (r) {
if (stock[String(r.value)] === false && !r.checked) {
r.disabled = true;
var label = r.closest('label');
if (label && !label.querySelector('.hhx-oos')) {
label.classList.add('is-off');
var em = document.createElement('em'); em.className = 'hhx-choice-tag hhx-oos'; em.textContent = 'out of stock';
(label.querySelector('span') || label).appendChild(em);
}
}
});
});
return true;
}
function afterSizeSheet() {
if (markStockOnce()) return;
var sheet = document.querySelector('.hhx-sheet-wrap .hhx-sheet'); if (!sheet) return;
var obs = new MutationObserver(function () { if (markStockOnce()) obs.disconnect(); });
obs.observe(sheet, { childList: true, subtree: true });
setTimeout(function () { try { obs.disconnect(); } catch (e) {} }, 8000);
}
function wrapSize(name) {
var a = CTX.act; if (!a || typeof a[name] !== 'function') return;
var orig = a[name];
a[name] = function () { var r = orig.apply(this, arguments); setTimeout(afterSizeSheet, 0); return r; };
}
wrapSize('size'); wrapSize('addextra');
window.addEventListener('hh-crew:rendered', function () { onRender(); wireImpact(); });
wrapFreq();
onRender(); wireImpact();
})();
